import { render } from "./Formateurs.vue?vue&type=template&id=7f2fb2c2"
import script from "./Formateurs.vue?vue&type=script&lang=js"
export * from "./Formateurs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Alexandre-OlivierRenaud/formateurs-autorises/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__